import styled from '@emotion/styled';
import { DebouncedLoader } from 'components';
import { TabPane } from 'semantic-ui-react';
import { AddRoomButton } from './AddRoomButton';
import { NoRoomsSelectedPlaceholder } from './NoRoomsSelectedPlaceholder';
import { useLrwSessionRooms } from './useLrwSessionRooms';
import { useLrwSessionAllowedActions } from 'hooks';
import { LrwSessionRoomsTable } from './LrwSessionRoomsTable';

export const LrwSessionRooms = () => {
  const { isFetching, lrwRooms } = useLrwSessionRooms();
  const { canAssignRooms } = useLrwSessionAllowedActions();

  const availableRooms = isFetching ? 0 : lrwRooms?.length;
  const showAddRooms = availableRooms && canAssignRooms;

  if (isFetching) return <DebouncedLoader />;
  return (
    <TabPane>
      {showAddRooms ? (
        <S.Actions>
          <AddRoomButton />
        </S.Actions>
      ) : null}
      {lrwRooms?.length ? (
        <LrwSessionRoomsTable lrwRooms={lrwRooms} />
      ) : (
        <NoRoomsSelectedPlaceholder />
      )}
    </TabPane>
  );
};

const S = {
  Actions: styled.div`
    display: flex;
    justify-content: end;
  `,
};
